import React, { useState, useEffect } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PrivateRoute from './privateRoute';

import actions from '../store/actions';
import history from './history';
import Loading from '../components/Loading';
import Settings from '../pages/Settings';
import ChooseTool from '../pages/Home/ChooseTool';
import ChooseOrganization from '../pages/Home/ChooseOrganization';
import Video from '../pages/VideoPage/VideoPage';
import Builder from '../pages/Builder';
import Bots from '../pages/Home/Bots';
import NewBot from '../pages/NewBot/NewBot';
import NewBotCreate from '../pages/NewBot/Components/NewBotCreate';
import NewVoicebotCreate from '../pages/NewBot/Components/NewVoicebotCreate';
import OrgReportMainScreen from '../pages/Builder/Analyze/OrgReport/OrgReportMainScreen';
import Webchat from '../pages/Webchat';
import Auth from '../pages/Auth';
import Plans from '../pages/Plans/Plans';
import User from '../pages/User/User';
import SelectSector from '../pages/SelectSector/SelectSector';

function Routes(props) {
  const { isAuthenticated, loading } = props;

  const [prevDebounceList, setPrevDebounceList] = useState([]);

  // Debounce ativado quando ocorrer alguma mudança no criador como Criação de itens, modificação e deleção
  useEffect(() => {
    // So vai ativar o debounce quando a lista aumentar de tamanho
    if (props.debounceList.length >= prevDebounceList) {
      const handler = setTimeout(() => {
        if (props.debounceList.length > 0) {
          props.executeDebounce(props.debounceList);
        }
      }, props.debounceTime * 1000);
      return () => {
        clearTimeout(handler);
      };
    }
    setPrevDebounceList(props.debounceList);
  }, [prevDebounceList, props, props.debounceList]);

  const beforeCloseTab = (e) => {
    e.preventDefault();
    e.returnValue = '';
  };

  useEffect(() => {
    if (props.debounceList.length > 0) {
      window.addEventListener('beforeunload', beforeCloseTab);
    } else {
      window.removeEventListener('beforeunload', beforeCloseTab);
    }
    return () => window.removeEventListener('beforeunload', beforeCloseTab);
  }, [props.debounceList]);

  return (
    <ConnectedRouter history={history}>
      <Loading loading={loading} />
      <Switch>
        <Route exact path="/webchat/:botid" component={Webchat} />
        <PrivateRoute
          exact
          path="/selecionar-organizacao"
          component={ChooseOrganization}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/home"
          component={ChooseTool}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/home?code=:code"
          component={ChooseTool}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/video"
          component={Video}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/novo-bot"
          component={NewBot}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/novo-bot/criacao"
          component={NewBotCreate}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/novo-bot/criacao/:templateId"
          component={NewBotCreate}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/novo-voicebot"
          component={NewVoicebotCreate}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/bots"
          component={Bots}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path="/preferencias/:menu/:userId"
          component={Settings}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path="/preferencias/:menu"
          component={Settings}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path="/bots/"
          component={Builder}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/relatorio-org/:orgId"
          component={OrgReportMainScreen}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path="/planos/"
          component={Plans}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/user/:userId"
          component={User}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          exact
          path="/setor"
          component={SelectSector}
          isAuthenticated={isAuthenticated}
        />

        <Route path="/" component={Auth} />

        {/* <PrivateRoute path='/bots' exact={true} component={Bots} isAuthenticated={isAuthenticated}/> */}
        {/* <PrivateRoute exact path="/admin" component={Admin} isAuthenticated={isAuthenticated}
                        selectOrganization={selectOrganization}/> */}
        {/* <PrivateRoute exact path="/bots/canais/:botid" component={Builder} isAuthenticated={isAuthenticated}/> */}
        {/* <PrivateRoute path="/bots/canais" component={Channels} isAuthenticated={isAuthenticated}/> */}
      </Switch>
    </ConnectedRouter>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.authStatus.isLoggedIn,
  loading: state.common.commonStatus.loading,
  debounceList: state.debounce.list,
  debounceTime: state.debounce.time,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actions.DebounceCreators,
      ...actions.authActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
